module.exports = __webpack_public_path__ + "img/payout-tai-banner.7e629bc2.svg";